import {
	Collapsible,
	CollapsibleContent,
	CollapsibleTrigger,
} from '@cocoonspace/ui/components/collapsible'
import { FormField } from '@cocoonspace/ui/components/form'
import { cn } from '@cocoonspace/ui/lib/utils'
import { useLingui } from '@lingui/react/macro'
import { ChevronDownIcon, PencilIcon, PlusIcon } from 'lucide-react'

import {
	SectionTitle,
	SectionTitleBtn,
	SectionWrapper,
} from '~/components/sheet-section-wrapper'
import { useFormSectionCollapsible } from '../use-form-section-collapsible.hook'
import { AddVenueAndCocoon } from './add-venue-and-cocoon'
import { LocationCocoon } from './location-cocoon'
import { LocationEmpty } from './location-empty'
import { LocationRemote } from './location-remote'

export const LocationTab = () => {
	const { t } = useLingui()
	const { hasErrors, onOpenChange, open } = useFormSectionCollapsible(
		['location'],
		true,
	)

	return (
		<FormField
			name='location'
			render={({ field }) => {
				const isEmpty = !field.value?.type
				const isCocoon = field.value?.type === 'cocoon'
				const isRemote = field.value?.type === 'remote'
				const hasSpaces = field.value?.space_ids?.length

				const btnIcon = isEmpty ? <PlusIcon /> : <PencilIcon />
				const btnLabel = isEmpty ? t`Ajouter` : t`Modifier`

				return (
					<Collapsible
						open={open}
						onOpenChange={onOpenChange}
					>
						<SectionWrapper>
							<SectionTitle>
								<CollapsibleTrigger
									className={cn(
										'flex min-w-0 flex-1 items-center gap-2 text-left',
										{ 'text-destructive': hasErrors },
									)}
								>
									{t`Localisation`}
								</CollapsibleTrigger>

								<AddVenueAndCocoon
									initialStepId={hasSpaces ? 'priority' : 'locationType'}
									value={field.value}
									onChange={(data) => field.onChange(data)}
								>
									<SectionTitleBtn>
										{btnIcon}
										{btnLabel}
									</SectionTitleBtn>
								</AddVenueAndCocoon>

								<CollapsibleTrigger
									aria-label={t`Localisation`}
									className='flex size-4 shrink-0 items-center [&[data-state=open]>svg]:rotate-180'
								>
									<ChevronDownIcon className='size-4 transition-transform' />
								</CollapsibleTrigger>
							</SectionTitle>

							<CollapsibleContent className='flex flex-col gap-4'>
								{isEmpty && <LocationEmpty />}
								{isCocoon && <LocationCocoon {...field} />}
								{isRemote && <LocationRemote />}
							</CollapsibleContent>
						</SectionWrapper>
					</Collapsible>
				)
			}}
		/>
	)
}
